import { isNxtHorizonHD } from "__common/constants/products";

export const apiField = 'tile_replacement_or_solarhooks';


export enum TileAttachmentType {
  TILE_REPLACEMENT = 1,
  SOLARHOOKS = 2,
  STANDOFFS = 3
} 



export const smTileReplacementsOrSolarhooks = (productId?, railsProductId?)=>{
  let tile_replacement_or_solarhooks_field = {
    type: 'Select',
    label: 'tile_replacement_or_solarhooks',
    apiField,
    missing: undefined,
    data: tileReplacementsOrSolarhooksData(railsProductId),
  };
  return tile_replacement_or_solarhooks_field
}

const tileReplacementsOrSolarhooksData = (railsProductId?) => { 
  return [{
    value: TileAttachmentType.TILE_REPLACEMENT,
    name: 'Tile Replacement',
  },
  {
    value: TileAttachmentType.SOLARHOOKS,
    name: 'Solarhooks',
  },
  ...(!isNxtHorizonHD(railsProductId) ? [
  {
    value: TileAttachmentType.STANDOFFS,
    name: 'Standoffs',
  },] 
  : []),
]};
